module.exports = __webpack_public_path__ + "static/media/jakubco.ca5b3bf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/jakubco.jpg
// module id = 560
// module chunks = 0